export default __webpack_public_path__ + "static/media/visa.d214fa0d.svg";